import { render, staticRenderFns } from "./ExpandableImage.vue?vue&type=template&id=43974123"
import script from "./ExpandableImage.vue?vue&type=script&lang=js"
export * from "./ExpandableImage.vue?vue&type=script&lang=js"
import style0 from "./ExpandableImage.vue?vue&type=style&index=0&id=43974123&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports